module.exports = __webpack_public_path__ + "static/media/lose.96855269.wav";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/sounds/lose.wav
// module id = 59
// module chunks = 0